// Module
var code = "<div class=\"nlgHealthCheckerTableReason.html table-responsive\"> <table class=nlgTable> <thead> <tr> <th ng-repeat=\"header in reason.headers\" translate>{{header}}</th> </tr> </thead> <tbody> <tr ng-repeat=\"row in reason.rows\"> <td ng-repeat=\"cell in row\" translate>{{cell}}</td> </tr> </tbody> </table> </div> ";
// Exports
module.exports = code;